import React, { useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import "./style.css";

export default function MobileDesktop({ header }) {
  const [childs, setChilds] = useState([]);

  const toggleMenu = () => {
    const menuDiv = document.getElementById("nav-mobile");
    menuDiv.classList.toggle("active");
  };

  const slideToLeft = (item) => {
    setChilds(item);
    const section1 = document.querySelector("#section1");
    const section2 = document.querySelector("#section2");
    section1.classList.add("left");
    section2.classList.add("left");
    section1.classList.remove("right");
    section2.classList.remove("right");
  };
  const slideToRight = () => {
    const section1 = document.querySelector("#section1");
    const section2 = document.querySelector("#section2");
    section1.classList.toggle("right");
    section2.classList.toggle("right");
    section1.classList.remove("left");
    section2.classList.remove("left");
  };

  return (
    <nav className="mobil-menu">
      <div className="w-full mx-auto px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
              onClick={toggleMenu}
            >
              <path
                d="M0 0H18V2H0V0ZM0 7H18V9H0V7ZM0 14H18V16H0V14Z"
                fill="black"
              />
            </svg>
            <Link to="/">
              <p className="font-ice text-black text-xl ml-5 uppercase">
                Tranquilo Bay
              </p>
            </Link>

            <ul
              id="nav-mobile"
              className="flex flex-col w-full items-center list-none justify-center text-white text-[20px] leading-[30px] font-poppins font-normal"
            >
              <div className="absolute z-50 right-4 top-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                  onClick={toggleMenu}
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>
              </div>
              <ul id="section1">
                {header?.menu?.map((item, index) => {
                  return (
                    <li key={index}>
                      <Link to={item.path}>
                        <span>{item.label}</span>
                      </Link>
                      {item.childs.length > 0 && (
                        <span onClick={() => slideToLeft(item.childs)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-chevron-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                            />
                          </svg>
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
              <div id="section2">
                <span className="absolute left-4 top-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="currentColor"
                    className="bi bi-chevron-left"
                    viewBox="0 0 16 16"
                    onClick={slideToRight}
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </span>
                <div className="py-[52px] mt-5 px-4 grid grid-cols-1 sm:grid-cols-2 gap-y-6">
                  {childs.map((item, index) => (
                    <Link to={item.path} key={index}>
                      <div className="flex">
                        <div>
                          <GatsbyImage
                            image={item?.img?.asset?.gatsbyImageData}
                            alt="menu-image"
                          />
                        </div>
                        <div className="ml-[18px] max-w-[213px]">
                          <p className="text-base font-poppins font-normal underline">
                            {item.title}
                          </p>
                          <p className="text-[15px] mt-[14px] leading-[22px] font-normal font-poppins text-[#868686]">
                            {item.caption}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
